// extracted by mini-css-extract-plugin
module.exports = {"text":"offer-details-module--text--3ib7C","article":"offer-details-module--article--3mkJL"};